import Clazz from '../common/Clazz';

/**
 * 元件基类，元件是组件（Component）管理的对象
 */
export default class Element extends Clazz {
    /**
     * 构造方法
     * @param {object} options 可选项
     */
    constructor(options = {}) {
        super(options);

        /**
         * 控制器组件对象
         * @type {object}
         */
        this._controller = null;
        /**
         * 反馈是否启用，只有启用的反馈才会被绘制
         * @type {boolean} 
         */
        this._enabled = true;
    }

    /**
     * 添加到控制器组件中
     * @param {Object}  controller 控制器组件对象
     */
    addTo(controller) {
        if (controller) {
            controller.add(this);
            return this;
        }
        return null;
    }

    /**
     * 删除元件
     */
    remove() {
        return this.removeFrom(this._controller);
    }

    /**
     * 从控制器组件中删除此元件
     * @param {object} controller 控制器组件对象
     */
    removeFrom(controller) {
        if (controller) {
            controller.delete(this);
            return this;
        }
        return null;
    }

    /**
     * 添加到控制器时调用，执行初始化操作
     * @param {object} controller 控制器实例
     */
    onAdd(controller) {
        this._controller = controller;
    }

    /**
     * 从控制器中删除时调用，执行数据清理
     */
    onRemove() {
        this._controller = null;
    }

    /**
     * 清空反馈中的所有符号.
     * @return {undefined}
     */
    clear() {
    }

    /**
     * 启用反馈
     */
    enable() {
        this._enabled = true;
    }

    /**
     * 停用反馈
     */
    disable() {
        this._enabled = false;
    }

    /**
     * 获取反馈的启用状态
     */
    enabled() {
        return this._enabled;
    }
}
